import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { ProjectCard } from "@/components/ProjectCard";
import { useProjects } from "@/hooks/useData";

export const ProjectsShowcase = () => {
  const { data: projects = [] } = useProjects("?featured=true");
  return (
    <section className="bg-[#F6F5F2]" data-testid="projects-showcase">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-32">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
          <SectionHeading eyebrow="Client References" title="Realised across" accent="the world." description="From private villas to commercial projects, Afurnix supports clients across countries and project types." />
          <Link to="/projects" className="label-eyebrow text-[11px] text-[#2C2A29] border-b border-[#2C2A29] pb-1 hover:text-[#9E8773] hover:border-[#9E8773] transition-colors whitespace-nowrap" data-testid="projects-viewall">
            View all projects
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {projects.slice(0, 3).map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08}>
              <ProjectCard project={p} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
